import { useEffect } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import styles from 'common/containers/Events/EventsConfiguration.scss';
import { Button, BUTTON } from 'components/common/Button/Button';
import Toggle from 'common/components/Toggle';
import PageHeader from 'components/common/PageHeader/PageHeader';

export default function EventsConfiguration(props) {
    const {
        institutionId,
        getInstitutionEventTypes,
        clearInstitutionEventTypes,
        toggleInstitutionEventType,
        eventTypes,
        onCreateEvent,
        viewEventTypeURLBuilder,
    } = props;

    useEffect(() => {
        getInstitutionEventTypes(institutionId);
        return () => {
            clearInstitutionEventTypes();
        };
    }, []);

    return (
        <div className={classnames(styles.parent, props.className)} data-cy="EventsConfiguration-Description">
            <PageHeader headerText={'Event Types Configuration'}/>
            <div className={styles.container}>
                <Button
                    bgcolor={BUTTON.BGCOLOR.BLUE}
                    color={BUTTON.COLOR.WHITE}
                    onClick={onCreateEvent}
                    data-cy="EventsConfiguration-onCreateEvent"
                >
                    Create Event Type
                </Button>
                <EventTypes
                    eventTypes={eventTypes}
                    viewEventTypeURLBuilder={viewEventTypeURLBuilder}
                    onToggle={
                        (eventTypeId, isEnabled) => toggleInstitutionEventType(
                            institutionId,
                            eventTypeId,
                            isEnabled
                        )
                    }
                    data-cy="EventsConfiguration-EventTypes"
                />
            </div>
        </div>
    );
}

export function EventTypes({ eventTypes, onToggle, viewEventTypeURLBuilder }) {
    eventTypes = eventTypes || [];
    const handleEventTypeChange = (event) => {
        const {
            target: {
                checked: isEnabled,
                name: eventTypeId
            }
        } = event;
        onToggle(eventTypeId, isEnabled);
    };

    return (
        <div className={styles.eventTypesList} data-cy="EventsConfiguration-eventTypesList">
            {
                eventTypes.map(eventType => (
                    <EventType
                        eventTypeId={eventType.id}
                        isEnabled={eventType.isEnabled}
                        key={eventType.id}
                        displayName={eventType.displayName}
                        onChangeHandler={handleEventTypeChange}
                        to={viewEventTypeURLBuilder(eventType.id)}
                    />
                ))
            }
        </div>);
}

export function EventType({ onChangeHandler, eventTypeId, isEnabled, displayName, to }) {
    return (
        <div className={styles.eventType} data-cy="EventsConfiguration">
            <Toggle
                name={eventTypeId}
                onChange={onChangeHandler}
                defaultChecked={isEnabled}
                label={displayName}
            />
            <Link
                className={styles.viewEventType}
                to={to}
            >
                View
            </Link>
        </div>
    );
}

